import {useEffect, useRef} from 'react'
import Button from '../Button/Button.tsx'
import css from './ConfirmDialog.module.css'
import {TextH3, TextNorm} from "../Text";
import CloseIcon from '../../../assets/icons/icon-close.svg?react'

interface ConfirmDialogProps {
    isOpen: boolean
    title: string
    text: string
    confirmButtonTitle: string
    onConfirm: () => void
    onClose: () => void
}

const ConfirmDialog = ({isOpen, title, text, confirmButtonTitle, onConfirm, onClose}: ConfirmDialogProps) => {
    const dialogRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dialogRef.current && !dialogRef.current.contains(event.target as Node)) {
                onClose()
            }
        }

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [isOpen, onClose])

    if (!isOpen) return null

    return (
        <div className={css.overlay}>
            <div className={css.dialog} ref={dialogRef}>
                <div onClick={onClose} className={css.close}><CloseIcon /></div>
                <TextH3 className={css.title}>{title}</TextH3>
                <TextNorm className={css.text}>{text}</TextNorm>
                <div className={css.buttons}>
                    <Button onClick={onClose} title="Cancel" type="light" />
                    <Button onClick={onConfirm} title={confirmButtonTitle} type="danger" testId="confirm-dialog-confirm-btn" />
                </div>
            </div>
        </div>
    )
}

export default ConfirmDialog
